import { RowExportTypeExcel } from "types";
import { excel } from "utils";
import { PromiseToComeResponse } from "../../types";
import moment from "moment";


export function ExportExcelPromiseToCome({ dataList }: {
  dataList: PromiseToComeResponse['data'],
}) {
  const columns = [
    { header: 'NO', key: 'no', width: 5 },
    { header: 'CODE', key: 'code', width: 10 },
    { header: 'VENDOR NAME', key: 'vendor_name', width: 20 },
    { header: 'PO ID', key: 'po_id', width: 20 },
    { header: 'ORDER DATE', key: 'order_date', width: 20 },
    { header: 'TOTAL QTY', key: 'total_qty', width: 20 },
    { header: 'PROMISE DATE', key: 'promise_date', width: 20 },
  ];

  const dataMap: RowExportTypeExcel[] = dataList.map((item, index: number) => {

    return {
      no: index + 1,
      code: item.vendor_code,
      product_name: item.vendor_name,
      po_id: item.trx_code,
      order_date: moment(item.transaction_date).format('DD/MM/YYYY'),
      total_qty: {
        text: Number(item.total_qty) ?? '-',
        style: {
          numFmt: '#,##0',
        }
      },
      promise_date: moment(item.promize_date).format('DD/MM/YYYY'),
    }
  })

  excel({
    dataList: dataMap,
    column: columns,
    module: 'INVENTORY',
    title: 'PURCHASE ORDER PROMISES TO COME',
    fileName: 'Purchase_Order_Promises_to_come',
  });
}

